import PropTypes from "prop-types";
import React from "react";


export const CatchAreasCount = (props) => {
  const {
    className,
    title,
    count,
  } = props;

  return (
    <p className={`${className}  catch-areas-count`}>
      <span className="catch-areas-count__title">{title}</span>
      <span className="catch-areas-count__count">{count}</span>
    </p>
  );
};


CatchAreasCount.propTypes = {
  className: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};
